import { createAsyncThunk } from '@reduxjs/toolkit'
import { instance } from '../api/api'
import { GetOrdersResponseType, OrdersType } from './types'

export const getOrders = createAsyncThunk(
  'orders/getPlaceOrders',
  async ({ token }: { token: string }, thunkAPI) => {
    try {
      const response = await instance.get<GetOrdersResponseType>('orders', {
        headers: { authorization: `Bearer ${token}` },
      })
      return response.data
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return thunkAPI.rejectWithValue('Unauthorised')
      }
      return thunkAPI.rejectWithValue(error?.response?.data || 'An error occurred')
    }
  },
)

export const getCurrentOrder = createAsyncThunk(
  'orders/getCurrentPlaceOrders',
  async ({ token, currentPlace }: { token: string; currentPlace: number }, thunkAPI) => {
    try {
      const response = await instance.get<OrdersType[]>(`orders/${currentPlace}`, {
        headers: { authorization: `Bearer ${token}` },
      })

      return response.data[0]
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return thunkAPI.rejectWithValue('Unauthorised')
      }
      return thunkAPI.rejectWithValue(error?.response?.data || 'An error occurred')
    }
  },
)

export const createOrder = createAsyncThunk(
  'orders/createOrder',
  async ({ data, token }: { data: any; token: string }, thunkAPI) => {
    try {
      const response = await instance.post<any>('orders', data, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
        },
      })

      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || 'Something went wrong')
    }
  },
)

export const deleteCurrentPlaceOrders = createAsyncThunk(
  'orders/deletCurrentPlaceOrders',
  async ({ orderId, token }: { orderId: number; token: string }, thunkAPI) => {
    try {
      const response = await instance.delete<OrdersType>(`orders/${orderId}`, {
        headers: { authorization: `Bearer ${token}` },
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        errors: [error.message],
        fieldsErrors: undefined,
      })
    }
  },
)

export const updateOrder = createAsyncThunk(
  'orders/updateOrder',
  async ({ orderId, data, token }: { orderId: number; data: any; token: string }, thunkAPI) => {
    try {
      const response = await instance.patch<OrdersType>(`orders/${orderId}`, data, {
        headers: { authorization: `Bearer ${token}` },
      })
      return response.data
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return thunkAPI.rejectWithValue('Unauthorised')
      }
      return thunkAPI.rejectWithValue(error?.response?.data || 'An error occurred')
    }
  },
)

export const removeProductFromOrder = createAsyncThunk(
  'orders/removeProductFromOrder',
  async (
    { orderId, productId, token }: { orderId: number; productId: number; token: string },
    thunkAPI,
  ) => {
    try {
      // Sending a PATCH request to remove the product from the order
      const response = await instance.patch(
        `orders/${orderId}/products/${productId}`,
        { orderId, productId },
        {
          headers: { authorization: `Bearer ${token}` },
        },
      )
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        errors: [error.message],
        fieldsErrors: undefined,
      })
    }
  },
)
